// extracted by mini-css-extract-plugin
export default {"bannerContainer":"sJcHE642nvhmTObzz2_0","banner":"hTaalLN8yedyS4rPa1sd","bannerImg":"DYxl3tXOm2jPICSFXr3X"};